export default __webpack_public_path__ + "static/media/IncompleteCheck.2a01875b.svg";